import { render, staticRenderFns } from "./PublicationPreview.vue?vue&type=template&id=60ca0f9c&scoped=true&"
import script from "./PublicationPreview.vue?vue&type=script&lang=js&"
export * from "./PublicationPreview.vue?vue&type=script&lang=js&"
import style0 from "./PublicationPreview.vue?vue&type=style&index=0&id=60ca0f9c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ca0f9c",
  null
  
)

export default component.exports